import initialAuthState from "../data/initialAuthState";

function authReducer(state, action) {
    switch (action.type) {
        case 'refreshUserInfo' : {
            return {
                ...state,
                user : (action.payload.user ? action.payload.user : state.user),
                token : (action.payload.token ? action.payload.token : state.token)
            };
        }
        case 'loginSuccess': {
            return {
                ...state,
                fetching : false,
                error: undefined,
                user : action.payload.user,
                token : action.payload.token,
                refresh_token : action.payload.refresh_token
            };
        }
        case 'loginFailed': {
            return {
                ...state,
                fetching: false,
                error: action.payload
            };
        }
        case 'loginPending': {
            return {
                ...state,
                fetching: true
            };
        }
        case 'loginOut': {
            return {
                ...state,
                ...initialAuthState,
            };
        }
        default: {
            throw new Error('unhandled action');
        }
    }
}

export default authReducer;